import IFeaturedCollection from "../models/IFeaturedCollection";
import INewsItem from "../models/INewsItem";
import INFTBestUser from "../models/INFTBestUser";
import INFTUserData from "../models/INFTUserData";

const API_URL = "https://api.yetiswap.app";

const API_GET_PROFILE_URL = (address: string) => `${API_URL}/Profile/Get/${address.toLowerCase()}`;
const API_GET_NONCE_URL = (address: string) => `${API_URL}/nonce/${address.toLowerCase()}`;
const API_SAVE_PROFILE_URL = (address: string) => `${API_URL}/Profile/Save/${address.toLowerCase()}`;

const API_CHECK_USERNAME_AVALIABLE_URL = `${API_URL}/Profile/UsernameAvaliable`;
const API_CHECK_EMAIL_AVALIABLE_URL = `${API_URL}/Profile/EmailAvaliable`;
const API_GET_BEST_SELLER_USERS_URL = `${API_URL}/nftMarket/getBestSellerUsers`;
const API_GET_BEST_BUYER_USERS_URL = `${API_URL}/nftMarket/getBestBuyerUsers`;
const API_GET_NEWS_URL = `${API_URL}/nftMarket/getNews`;
const API_GET_FEATURED_COLLECTIONS_URL = `${API_URL}/nftMarket/getFeaturedCollections?network=Boba`;

const API_LIKE_NFT_URL = `${API_URL}/nftMarket/likeNft`;
const API_LIKE_COLLECTION_URL = `${API_URL}/nftMarket/likeCollection`;
const API_UNLIKE_NFT_URL = `${API_URL}/nftMarket/unlikeNft`;
const API_UNLIKE_COLLECTION_URL = `${API_URL}/nftMarket/unlikeCollection`;
const API_GET_USER_COLLECTION_LIKES_URL = `${API_URL}/nftMarket/getUserCollectionLikes`;
const API_GET_USER_NFT_LIKES_URL = `${API_URL}/nftMarket/getUserNftLikes`;
const API_GET_NFT_LIKE_COUNT_URL = `${API_URL}/nftMarket/getNftsLikeCounts`;
const API_GET_COLLECTION_LIKE_COUNT_URL = `${API_URL}/nftMarket/getCollectionsLikeCounts`;


const CheckUsernameAvaliable = (username: string): Promise<boolean> => {
    return new Promise(resolve => {
        fetch(API_CHECK_USERNAME_AVALIABLE_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username })
        }).then(res => res.json()).then(res => {
            if (res?.result?.code == "1") {
                resolve(true);
            } else {
                resolve(false);
            }
        }).catch(e => resolve(false));
    })
}

const CheckEmailAvaliable = (email: string): Promise<boolean> => {
    return new Promise(resolve => {
        fetch(API_CHECK_EMAIL_AVALIABLE_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email })
        }).then(res => res.json()).then(res => {
            if (res?.result?.code == "1") {
                resolve(true);
            } else {
                resolve(false);
            }
        }).catch(e => resolve(false));
    })
}

const SaveUserProfile = (address: string, data: INFTUserData): Promise<boolean> => {
    return new Promise((resolve) => {
        fetch(API_SAVE_PROFILE_URL(address), {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(res => res.json()).then(res => {
            if (res?.result?.code == "1") {
                resolve(true);
            } else {
                resolve(false);
            }
        }).catch(e => { resolve(false) });
    });
}

const GetNonceForUser = (address: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        fetch(API_GET_NONCE_URL(address)).then(res => res.json()).then(res => {
            if (res && res.lastNonce !== null && res.lastNonce !== undefined) {
                resolve(res.lastNonce);
            } else {
                reject();
            }
        }).catch(e => { reject() });
    })
}

const GetUserProfileData = (address: string): Promise<INFTUserData> => {
    return new Promise((resolve, reject) => {
        fetch(API_GET_PROFILE_URL(address)).then(res => res.json()).then(res => {
            if (res?.result?.code == "-1") {
                reject();
            } else {
                resolve(res);
            }
        }).catch(e => { reject() });
    })
}

const GetBestSellerUserData = (): Promise<INFTBestUser[]> => {
    return new Promise((resolve, reject) => {
        fetch(API_GET_BEST_SELLER_USERS_URL).then(res => res.json()).then(res => {
            if (res?.result?.code == "-1") {
                reject();
            } else {
                resolve(res);
            }
        }).catch(e => { reject() });
    })
}

const GetBestBuyerUserData = (): Promise<INFTBestUser[]> => {
    return new Promise((resolve, reject) => {
        fetch(API_GET_BEST_BUYER_USERS_URL).then(res => res.json()).then(res => {
            if (res?.result?.code == "-1") {
                reject();
            } else {
                resolve(res);
            }
        }).catch(e => { reject() });
    })
}

const GetNewsData = (): Promise<INewsItem[]> => {
    return new Promise((resolve, reject) => {
        fetch(API_GET_NEWS_URL).then(res => res.json()).then(res => {
            if (res?.result?.code == "-1") {
                reject();
            } else {
                resolve(res);
            }
        }).catch(e => { reject() });
    })
}

const GetFeaturedCollectionsData = (): Promise<IFeaturedCollection[]> => {
    return new Promise((resolve, reject) => {
        fetch(API_GET_FEATURED_COLLECTIONS_URL).then(res => res.json()).then(res => {
            if (res?.result?.code == "-1") {
                reject();
            } else {
                resolve(res);
            }
        }).catch(e => { reject() });
    })
}

const LikeNFT = (payload: {
    userAddress: string,
    collectionAddress: string,
    tokenID: string,
    signature: string
}): Promise<boolean> => {
    return new Promise((resolve) => {
        fetch(API_LIKE_NFT_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        }).then(res => res.json()).then(res => {
            if (res?.result?.code == "1") {
                resolve(true);
            } else {
                resolve(false);
            }
        }).catch(e => { resolve(false) });
    });
}

const UnLikeNFT = (payload: {
    userAddress: string,
    collectionAddress: string,
    tokenID: string,
    signature: string
}): Promise<boolean> => {
    return new Promise((resolve) => {
        fetch(API_UNLIKE_NFT_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        }).then(res => res.json()).then(res => {
            if (res?.result?.code == "1") {
                resolve(true);
            } else {
                resolve(false);
            }
        }).catch(e => { resolve(false) });
    });
}

const LikeCollection = (payload: {
    userAddress: string,
    collectionAddress: string,
    signature: string
}): Promise<boolean> => {
    return new Promise((resolve) => {
        fetch(API_LIKE_COLLECTION_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        }).then(res => res.json()).then(res => {
            if (res?.result?.code == "1") {
                resolve(true);
            } else {
                resolve(false);
            }
        }).catch(e => { resolve(false) });
    });
}

const UnLikeCollection = (payload: {
    userAddress: string,
    collectionAddress: string,
    signature: string
}): Promise<boolean> => {
    return new Promise((resolve) => {
        fetch(API_UNLIKE_COLLECTION_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        }).then(res => res.json()).then(res => {
            if (res?.result?.code == "1") {
                resolve(true);
            } else {
                resolve(false);
            }
        }).catch(e => { resolve(false) });
    });
}

const GetUserCollectionLikes = (payload: {
    userAddress: string
}): Promise<any[]> => {
    return new Promise((resolve) => {
        fetch(API_GET_USER_COLLECTION_LIKES_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        }).then(res => res.json()).then(res => {
            if (Array.isArray(res)) {
                resolve(res);
            } else {
                resolve([]);
            }
        }).catch(e => { resolve([]) });
    });
}

const GetUserNFTLikes = (payload: {
    userAddress: string
}): Promise<any[]> => {
    return new Promise((resolve) => {
        fetch(API_GET_USER_NFT_LIKES_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        }).then(res => res.json()).then(res => {
            if (Array.isArray(res)) {
                resolve(res);
            } else {
                resolve([]);
            }
        }).catch(e => { resolve([]) });
    });
}

const GetNFTLikeCounts = (payload: {
    collectionAddress: string,
    tokenID: string
}[]): Promise<any[]> => {
    return new Promise((resolve) => {
        fetch(API_GET_NFT_LIKE_COUNT_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ nfts: payload })
        }).then(res => res.json()).then(res => {
            if (Array.isArray(res)) {
                resolve(res);
            } else {
                resolve([]);
            }
        }).catch(e => { resolve([]) });
    });
}

const GetCollectionLikeCounts = (payload: {
    collectionAddress: string
}[]): Promise<any[]> => {
    return new Promise((resolve) => {
        fetch(API_GET_COLLECTION_LIKE_COUNT_URL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ collections: payload })
        }).then(res => res.json()).then(res => {
            if (Array.isArray(res)) {
                resolve(res);
            } else {
                resolve([]);
            }
        }).catch(e => { resolve([]) });
    });
}

const LikeServices = {
    LikeNFT,
    UnLikeNFT,
    LikeCollection,
    UnLikeCollection,
    GetUserCollectionLikes,
    GetUserNFTLikes,
    GetNFTLikeCounts,
    GetCollectionLikeCounts
}

const ProfileServices = {
    GetNonceForUser,
    GetUserProfileData,
    SaveUserProfile,
    CheckUsernameAvaliable,
    CheckEmailAvaliable
}

const NFTMarketServices = {
    GetBestSellerUserData,
    GetBestBuyerUserData,
    GetNewsData,
    GetFeaturedCollectionsData
}

export { ProfileServices, NFTMarketServices, LikeServices };